import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { select, call } from 'redux-saga/effects';
import { userProfile, userPermissions } from 'redux/saga/entities/bound';
import { scrollToTop } from 'redux/saga/helpers';
import { isLoggedIn } from 'redux/saga/selectors';
import loginRedirectUrl from 'helpers/loginRedirectUrl';
import { memberStatus } from 'enums/memberStatus';

export const videosOnEnterSaga = function* videosOnEnterSaga(client, nextState, replaceState, redirect = '/') {
  if (!(yield select(isLoggedIn))) {
    return yield call(replaceState, loginRedirectUrl(nextState.location));
  }

  yield call(scrollToTop);
  const profile = yield call(fetchEntityIfNeeded, userProfile, [client]);
  const permissions = yield call(fetchEntityIfNeeded, userPermissions, [client, profile.id]);
  const isActiveMember = profile.membership.status === memberStatus('ACTIVE');
  const isLivePermissioned = permissions.feature_videos_live_tests;

  if (isActiveMember || isLivePermissioned) {
    return;
  }

  return yield call(replaceState, redirect);
};

export const liveOnEnterSaga = function* liveOnEnterSaga(client, nextState, replaceState, redirect = '/') {
  if (!(yield select(isLoggedIn))) {
    return yield call(replaceState, loginRedirectUrl(nextState.location));
  }

  yield call(scrollToTop);
  const profile = yield call(fetchEntityIfNeeded, userProfile, [client]);
  const permissions = yield call(fetchEntityIfNeeded, userPermissions, [client, profile.id]);

  if (permissions.feature_videos_live_tests) {
    return;
  }
  return yield call(replaceState, redirect);
};

export const liveAdminOnEnterSaga = function* liveAdminSaga(client, nextState, replaceState) {
  if (!(yield select(isLoggedIn))) {
    return yield call(replaceState, loginRedirectUrl(nextState.location));
  }

  const profile = yield call(fetchEntityIfNeeded, userProfile, [client]);
  const permissions = yield call(fetchEntityIfNeeded, userPermissions, [client, profile.id]);

  if (!permissions.feature_admin_video_kiosk) {
    return yield call(replaceState, '/');
  }
};

export const liveHowItWorksOnEnterSaga = function* liveHowItWorksOnEnterSaga(client, nextState, replaceState) {
  if (!(yield select(isLoggedIn))) {
    return yield call(replaceState, loginRedirectUrl(nextState.location));
  }

  return yield call(scrollToTop);
};
